/** Inline sparkline. Unlike the prototype version this tolerates empty and
 *  single-point series, which real API data produces (a brand-new scraper has
 *  no history, and Math.max(...[]) is -Infinity). */
export function Spark({
  data,
  color = 'var(--accent)',
  w = 120,
  h = 28,
}: {
  data: number[];
  color?: string;
  w?: number;
  h?: number;
}) {
  if (data.length === 0) {
    return <svg width={w} height={h} style={{ display: 'block' }} aria-hidden />;
  }

  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  // A single point has no span to divide by; draw it as a flat mid-line.
  const step = data.length > 1 ? w / (data.length - 1) : 0;

  const pts = data
    .map((v, i) => {
      const x = data.length > 1 ? i * step : w / 2;
      const y = h - ((v - min) / range) * (h - 4) - 2;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    // Shrinks with its container (narrow KPI tiles) instead of overflowing.
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      style={{ display: 'block', width: '100%', maxWidth: w, height: h }}
      aria-hidden
    >
      <polyline
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        vectorEffect="non-scaling-stroke"
        points={pts}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline fill={color} fillOpacity="0.08" stroke="none" points={`0,${h} ${pts} ${w},${h}`} />
    </svg>
  );
}
